import { atom } from 'recoil';

export const orderPayload = atom({
    key: 'awsco-orderPayload',
    default: {
        appProfile: null,
        appProfileDetails: null,
        appName: null,
        applicationName: null,
        appShortName: null,
        sector: null,
        sectorDetails: null,
        businessCategory: null,
        region: null,
        regionDetail: null,
        environments: [],
        budgetCode: null,
        csaApproval: null,
        isCSAApprovalsComplete: null,
        techDocLink: null,
        onPremHCode: null,
        onPremHCodeDetails: null,
        additionalInfo: null,
        businessAppDetails: null,
        businessApp: null,
        businessSponsor: null,
        businessSponsorDetails: null,
        dataClassification: null,
        entityDetails: null,

        // Resource Setion
        cloudType: null,
        isaNumber: null,
        onboardingCategory: null,
        // csaApprovedArch: 'no',
        tacRequest: null,
        prevCloudOnboardReq: null,
        csa: null,
        csaDetails: null,
        deletedFiles: [],
        isChinaRegion: 'no',
        adGroup: null,
        privilegedADGroupList: [{ contributorValue: '' }],
        privilegedADGroup: null,
        privilegedADGroupOwner: null,
        privilegedADGroupOwnerDetails: null,

        estimatedCost: {
            details: [],
            totalRecurringCost: {
                frequency: 'monthly',
                estCost: null,
                currency: 'USD',
            },
            notes: 'There is no cost for this Cloud onboarding request, however there will be cost involved based on the service Name defined at the Resource Group level for your resources that being provisioned in future.',
        },
        catalogCode: null,
        placeNewOrder: new Date(),
        validationStatus: 'clearValidation',
        isTouched: false,
    },
});

export const urlParams = atom({
    key: 'awsco-urlParams',
    default: {
        journeyId: null,
        appRegistrationId: null,
    },
});

export const isValidApplicationName = atom({
    key: 'awsco-validApplicationName',
    default: false,
});
export const isAppNameValid = atom({
    key: 'awsco-isAppNameValid',
    default: true,
});
export const isAppNameValid1 = atom({
    key: 'awsco-isAppNameValid1',
    default: true,
});

export const isAppShortNameValid = atom({
    key: 'awsco-isAppShortNameValid',
    default: false,
});
export const isAppShortNameExist = atom({
    key: 'awsco-isAppShortNameExist',
    default: false,
});

export const isValidISANumber = atom({
    key: 'awsco-isValidISANumber',
    default: false,
});

export const isValidOwners = atom({
    key: 'awsco-isValidOwners',
    default: {
        isvalidAppOwner: true,
        isvalidCertificateOwner1: true,
        isvalidCertificateOwner2: true,
    },
});

export const toggleSspModels = atom({
    key: 'awsco-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isApplicationOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
        isNonPrivilegedADGroupOpen: false,
        isPrivilegedADGroupOpen: false,
        isADGroupModalOpen: false,
    },
});

export const costEstimateState = atom({
    key: 'awsco-costEstimateState',
    default: null,
});
export const isLoadingCostApiState = atom({
    key: 'awsco-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});

export const orderId = atom({
    key: 'awsco-orderId',
    default: '',
});

export const isNonPrivilegedADGroupValid = atom({
    key: 'awsco-isNonPrivilegedADGroupValid',
    default: false,
});

export const isPrivilegedADGroupValid = atom({
    key: 'awsco-isPrivilegedADGroupValid',
    default: false,
});

export const SecondaryApprover = atom({
    key: 'awsco-secondaryApprover',
    default: { selectedFieldFrom: { module: null, subModule: null }, value: { groupOwner: null, groupOwnerDetails: null } },
});

export const uploadedFilesState = atom({
    key: 'awsco-uploadedFilesState',
    default: [],
});

export const isBudgetCodeValid = atom({
    key: 'awsco-isBudgetCodeValid',
    default: true,
});
export const isValidCloudDocLink = atom({
    key: 'awsco-isValidDocLink',
    default: true,
});
